import Process from '@features/processes/components/Process';
import { ProcesoDivision } from '@interfaces/firestore-documents.interfaces';
import { Grid } from '@mui/material';
import { FiltersNoResults } from '@features/filters';

interface Props {
	editingProcessID?: number | string;
	isEditing: boolean;
	onProcessEditionClick(data: ProcesoDivision): () => void;
	processes: ProcesoDivision[];
	scrollPage: number;
	resultsHeight: string;
}

const ProcessesContainer: React.FC<Props> = ({
	editingProcessID,
	isEditing,
	onProcessEditionClick,
	processes,
	scrollPage,
	resultsHeight,
}) => {
	// Refs

	// // Hooks
	// const isSmallScreen = useMediaQuery((theme: Theme) => theme.breakpoints.down(1521));
	// // Variables
	// // const processesAmount = isEditing ? (isSmallScreen ? 1 : 2) : isSmallScreen ? 2 : 3;
	return (
		<div style={{ width: '100%', display: 'block' }}>
			<Grid container spacing={0.6}>
				{processes.length > 0 ? (
					processes.slice(0, scrollPage * 9).map((process) => (
						<Grid
							key={`division-process-${process.id_proceso}`}
							item
							xs={12}
							sm={12}
							md={isEditing ? 12 : 6}
							lg={isEditing ? 12 : 6}
							xl={isEditing ? 6 : 4}
						>
							<Process
								data={process}
								isActive={process.id_proceso === editingProcessID}
								onClick={onProcessEditionClick(process)}
								width={`100%`}
							/>
						</Grid>
					))
				) : (
					<FiltersNoResults height={resultsHeight} />
				)}
			</Grid>
		</div>
	);
};

export default ProcessesContainer;
